import GenericDialog from "./generic";
import { updateSite } from "api/site";
import { Site, SiteUpdateBody } from "api/types/site";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import SiteGeneralForm, { SiteGeneralFormType } from "widgets/forms/sites/general";

const SiteInfoDialog = (props: {
  site?: Site;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { site, isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const doUpdateSite = async (formData: SiteGeneralFormType) => {
    const body: SiteUpdateBody = {
      id: site?.id,
      name: formData?.name,
      reference: formData?.reference,
      siteArea: formData?.siteArea,
      siteId: formData?.siteId,
      reportEmail: formData?.reportEmail,
    };

    dispatch(setLoading(true));
    const { status, isLoading } = await updateSite(body);
    dispatch(setLoading(isLoading));

    if (status && status === 200) {
      onSuccess();
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.site.info.title.general")}
      onExit={onClose}
      size="lg"
    >
      <SiteGeneralForm
        values={{
          name: site?.name || "",
          reference: site?.reference || "",
          siteArea: site?.siteArea || "",
          siteId: site?.siteId || "",
          reportEmail: site?.reportEmail || "",
        }}
        submit={doUpdateSite}
        onClose={onClose}
      />
    </GenericDialog>
  );
};

export default SiteInfoDialog;
  